import { render } from "./invoice_breakdown.vue?vue&type=template&id=75592f52&scoped=true"
import script from "./invoice_breakdown.vue?vue&type=script&lang=js"
export * from "./invoice_breakdown.vue?vue&type=script&lang=js"

import "./invoice_breakdown.vue?vue&type=style&index=0&id=75592f52&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75592f52"]])

export default __exports__